"use client";

import { useLanguage } from "@/context/LanguageContext";

const SomeWatchDogText = () => {
  const { language } = useLanguage();
  const copy = {
    cs: {
      label: "O službě",
      title: "Hlídáme nejdůležitější realitní weby za vás",
      lead: "Už nikdy vám neunikne žádná nabídka. Náš hlídací pes prohledává realitní portály nepřetržitě a jakmile se objeví nová nabídka, okamžitě vás upozorní.",
      tiers: [
        ["zdarma", "14 dní", "Základní", "Bez kreditní karty"],
        ["49 Kč", "měsíčně", "Standardní", "Denní report do mailu"],
        ["89 Kč", "měsíčně", "Prémiový", "Notifikace do 2 hodin"],
        ["249 Kč", "měsíčně", "Profesionální", "Okamžité notifikace"],
      ],
    },
    en: {
      label: "About the service",
      title: "We monitor the most important real estate sites for you",
      lead: "Never miss a listing again. Our watchdog continuously scans real estate portals and alerts you immediately when a new offer appears.",
      tiers: [
        ["FREE", "14 days", "Basic", "No credit card"],
        ["49 CZK", "monthly", "Standard", "Daily email report"],
        ["89 CZK", "monthly", "Premium", "Notifications within 2 hours"],
        ["249 CZK", "monthly", "Professional", "Instant notifications"],
      ],
    },
  }[language];

  return (
    <div className="watchdog-text-root">
      <div className="section-label">{copy.label}</div>
      <h2 className="section-title">{copy.title}</h2>
      <p className="watchdog-lead">{copy.lead}</p>

      <div className="watchdog-tiers">
        {copy.tiers.map(([label, frequency, name, sub], index) => (
          <div
            key={name}
            className={`${index === 3 ? "watchdog-tier-card" : "watchdog-tier-card--muted"}`}
          >
            <span className="watchdog-tier-label">
              {label}
              <span> {frequency}</span>
            </span>
            <span className="watchdog-tier-name">{name}</span>
            <span className="watchdog-tier-sub">{sub}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SomeWatchDogText;
